import {
  PNL_ANALYTICS_API_ACTION_TYPES,
  UPDATE_CONTRACT_TYPE,
  UPDATE_DURATION,
  UPDATE_FUNDING_CHART_DATA,
  UPDATE_SELECTED_CURRENCY,
} from 'actionTypes/pnlAnaltyics';
import { PNL_ANALYTICS_CHART_APIS, USER_PROFILE } from 'constants/api';
import createAction from 'helpers/createAction';
import type {
  FundingChartPayload,
  GetAccountAnalyticsScalperRebateArgs,
} from 'types/actions/pnlAnalytics';

import { authAction } from './user';

const updateFundingChartDataAction = createAction(UPDATE_FUNDING_CHART_DATA);
const updateDurationAction = createAction(UPDATE_DURATION);
const updateContractTypeAction = createAction(UPDATE_CONTRACT_TYPE);
const updateSelectedCurrency = createAction(UPDATE_SELECTED_CURRENCY);

const fetchFundingChartData = (
  payload: FundingChartPayload
): {
  types: {
    LOAD: 'LOAD_FETCH_FUNDING_CHART_DATA';
    SUCCESS: 'FETCH_FUNDING_CHART_DATA_SUCCESS';
    FAIL: 'FETCH_FUNDING_CHART_DATA_FAIL';
  };
  promise: ({ request }: { request: any }) => Promise<any>;
} => {
  return {
    types: PNL_ANALYTICS_API_ACTION_TYPES.FETCH_FUNDING_CHART_DATA,
    promise: ({ request }) =>
      request.get(PNL_ANALYTICS_CHART_APIS.FUNDING_CHART, payload),
  };
};

function getAccountAnalyticsScalperRebate(payload: GetAccountAnalyticsScalperRebateArgs) {
  return authAction({
    types: PNL_ANALYTICS_API_ACTION_TYPES.GET_ACCOUNT_ANALYTICS_SCALPER_REBATE,
    promise: ({ request }) =>
      request.get(USER_PROFILE.GET_ACCOUNT_ANALYTICS_SCALPER_REBATE, payload),
  });
}

export {
  updateFundingChartDataAction,
  updateDurationAction,
  updateContractTypeAction,
  fetchFundingChartData,
  updateSelectedCurrency,
  getAccountAnalyticsScalperRebate,
};
